window.rebuildCheckoutRequired = rebuildCheckoutRequired = () => {
    const locked = document.querySelector('body').dataset.cartLocked == 'true';
    const { checkout } = JSON.parse(document.querySelector('[data-checkout]').innerHTML);
    const { approved, updated_at } = checkout;
    const userUpdatedAt = parseInt(localStorage.getItem('checkout_update_at'));
    return !approved && updated_at != userUpdatedAt && !locked;
}

window.rebuildCheckoutItems = rebuildCheckoutItems = async () => {

    const { checkout } = JSON.parse(document.querySelector('[data-checkout]').innerHTML);
    const { items, restore } = checkout;

    return fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Bypass-Internal': 'true',
            'No-Queue': 'true'
        },
        body: JSON.stringify({
            items: [
                ...items
                    .map((item) => {
                        return {
                            id: item.id,
                            quantity: Object.keys(item.properties).includes('_original_qty') && item.properties['_original_qty'] ? parseInt(item.properties['_original_qty']) : item.quantity,
                            properties: item.properties
                        }
                    }),
                ...restore.map(([identifier, properties]) => {
                    const [id, quantity] = identifier.split(':');
                    return {
                        id: parseInt(id),
                        quantity: parseInt(quantity),
                        properties: properties
                    }
                })
            ]
        }),
    });
}

window.rebuildCheckoutLocalStorage = rebuildCheckoutLocalStorage = () => {

    const { checkoutId, checkout } = JSON.parse(document.querySelector('[data-checkout]').innerHTML);
    const { attributes, approved, updated_at, timeout } = checkout;

    localStorage.setItem('checkout_update_at', updated_at);
    localStorage.setItem('checkout_progress', true);
    localStorage.setItem('checkout_update_checkout_timeout', attributes['expires_at'] - (15 * 1000));
    localStorage.setItem('checkoutId', checkoutId);
    localStorage.setItem('username_key', attributes['username_key']);
    localStorage.setItem('checkout_timeout', timeout);
    localStorage.setItem('current_step', 2);
    // localStorage.removeItem('related_products');
}

window.rebuildCheckoutAttributes = rebuildCheckoutAttributes = async () => {
    return new Promise(async (resolve) => {
        const { checkout } = JSON.parse(document.querySelector('[data-checkout]').innerHTML);
        const { attributes } = checkout;
        const formData = new FormData();
        Object.keys(attributes).forEach((attrKey) => {
            formData.append(`attributes[${attrKey}]`, attributes[attrKey]);
        });
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Bypass-Internal': 'true',
                'No-Queue': 'true'
            },
            body: formData,
        });
        return resolve();
    })
}

window.refreshCheckoutStore = refreshCheckoutStore = async () => {
    const request = await fetch('/cart?view=rebuild_checkout', {
        headers: {
            'Bypass-Internal': 'true',
            'No-Queue': 'true'
        }
    });
    const response = await request.json();
    document.querySelector('[data-checkout]').innerHTML = JSON.stringify(response);
    return Promise.resolve();
}

window.rebuildCheckout = rebuildCheckout = async () => {

    await window.refreshCheckoutStore();
    document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));

    await window.clearDiscounts();
    document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));

    await window.clearCartAtributes();
    document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));

    await window.rebuildCheckoutItems();
    document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));

    await window.rebuildCheckoutLocalStorage();
    document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));

    await window.rebuildCheckoutAttributes();
    document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));

    await window.render();
    document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));

    return Promise.resolve();
}

document.addEventListener('DOMContentLoaded', async () => {

    const checkoutPresent = document.querySelector('body').dataset.checkoutPresent == 'true';

    if (window.queueActive() || !checkoutPresent || window.customer?.currentUserNumber?.startsWith('b2b_')) {
        return;
    }

    try {

        if (!window.rebuildCheckoutRequired()) {
            return;
        }

        document.getElementById('cart-icon-bubble').classList.add('loading');
        document.querySelector('.cart-icon-bubble-loading').classList.remove('hidden');
        document.dispatchEvent(new CustomEvent('queue-job:show', { bubbles: true, detail: 8 }));

        await window.rebuildCheckout();

        document.getElementById('cart-icon-bubble').classList.remove('loading');
        document.querySelector('.cart-icon-bubble-loading').classList.add('hidden');
        document.dispatchEvent(new CustomEvent('queue-job:end', { bubbles: true }));

    } catch (e) {
        const modalWindow = document.getElementById('checkout-response-error');
        if (modalWindow) {
            modalWindow.html = `File: <b>common-checkout.js</b><br /><br /><hr style="margin: 10px 0 5px;" />`;
            modalWindow.message = e;
            modalWindow.stack = e.stack;
            modalWindow.open();
        }
    }
});
